import React, { Component } from 'react';
import config from 'src/config';
import {Link} from 'react-router';
import {removeAuthToken, removeUserId} from '../../../logic/authHelpers';
import { Badge, ListGroup, ListGroupItem } from 'src/components/Common/reactstrap/lib';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

export class UserMenuContent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let balance = this.props.Balance.toLocaleString();
    return (
      <ListGroup>
        <ListGroupItem className="flex-space-between">
          <Link
            className="m-r-1_5 link"
            to={config.routes.user}
            >
            Настройки
          </Link>
        </ListGroupItem>
        <ListGroupItem className="flex-space-between">
          <Link
            className="m-r-1_5 link"
            to={config.routes.orders}>
            Заказы
          </Link>
          <span>{this.props.InmotionsCount}</span>
        </ListGroupItem>
       {/* <ListGroupItem className="flex-space-between">
          <a href="#" className="link">
            Сообщения
          </a>
          <span>3</span>
        </ListGroupItem>*/}
        <ListGroupItem className={'flex-space-between ' + ((balance.length > 7) ? 'w-180' : '')}>
          <Link
            className="link"
            to={config.routes.balance}
          >
            Баланс
          </Link>
          <span className={+this.props.Balance >= 0 ?"text-success" : "text-danger"}>
            {balance} &#8381;
          </span>
        </ListGroupItem>
        <ListGroupItem className="flex-space-between">
          <Link
            className="m-r-1_5 link"
            to={config.routes.garage}>
            Гараж
          </Link>
        </ListGroupItem>
        <ListGroupItem className="flex-space-between">
          <a className="m-r-1_5 link">
            Бизнес
          </a>
          <Badge color="warning">beta</Badge>
        </ListGroupItem>
        <ListGroupItem className="flex-space-between">
          <a className="link" onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            removeAuthToken();
            removeUserId();
            browserHistory.push({pathname: config.routes.main});
            window.location.reload();
          }} href="/">
            Выход
          </a>
        </ListGroupItem>
      </ListGroup>
    );
  }
}


export default connect(
  (state) => ({
    ...state.userReducer
  })
)(UserMenuContent);




/** WEBPACK FOOTER **
 ** ./src/components/User/elements/UserMenuContent.jsx
 **/